export default __webpack_public_path__ + "static/media/4ConnectionIssue.391f656d.png";